//@author: suthzy

const config = {

    mode: {
        debug: true,
        warn: true,
        error: true,
        info: true
    }
}

//export const nodeHost = "http://localhost:3000";

export default config;